export default __webpack_public_path__ + "static/media/kindly-open-source.6a23f78d.svg";